/**
 * Sync enamel active chrome for the waypoint placement tool.
 * Mapbox Draw already toggles `.active` on polygon/line buttons.
 */
export function applyPlacementToolChrome({ waypointBtn, markerBtn, standBtn, creationContext, drawMode }) {
  const btn = waypointBtn || markerBtn;
  const placing = drawMode === 'draw_point';
  const pointOn = Boolean(
    placing && (creationContext === 'point' || creationContext === 'marker' || creationContext === 'stand')
  );

  if (btn) {
    btn.classList.toggle('active', pointOn);
    btn.setAttribute('aria-pressed', pointOn ? 'true' : 'false');
  }
  if (standBtn) {
    standBtn.classList.toggle('active', false);
    standBtn.setAttribute('aria-pressed', 'false');
  }

  return { pointOn };
}
